/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { EducationLevel, OccupationGroup } from '../types/utils';
import { PaymentID } from './payment-model';
import { UpdateExperienceInput } from './update-experience-input';
import { CreateWalletInput } from './create-wallet-input';

export class UpdateUserInput {
	address?: string

	addressZipcode?: string

	addressCity?: string

	addressCountry?: string

	availableCash?: number

	cellphone?: string

	defaultPayment?: PaymentID

	employment?: string

	experience?: Array<UpdateExperienceInput>

	highestEducation?: EducationLevel

	monthlySalary?: number

	occupationGroup?: OccupationGroup

	prevEmployment?: string

	wallet?: CreateWalletInput
}